import type { SliceComponentProps } from "@commercekit/prismic";
import React from "react";
import type { ContactUsFormSlice } from "~/lib/prismic/types.generated";
import ContactUsFormHalfPage from "./variations/ContactFormHalfPage";
import ContactUsFormFullPage from "./variations/ContactFormFullPage";

const ContactUsForm = ({ slice }: SliceComponentProps<ContactUsFormSlice>) => {
  switch (slice.variation) {
    case "default": {
      return <ContactUsFormHalfPage slice={slice} />;
    }
    case "fullPage": {
      return <ContactUsFormFullPage slice={slice} />;
    }
    default:
      return <div className="hidden">Content</div>;
  }
};

export default ContactUsForm;
